import { render } from "./FridgeSettingsQuickButtonItem.vue?vue&type=template&id=129f1c28&scoped=true&ts=true"
import script from "./FridgeSettingsQuickButtonItem.vue?vue&type=script&lang=ts"
export * from "./FridgeSettingsQuickButtonItem.vue?vue&type=script&lang=ts"

import "./FridgeSettingsQuickButtonItem.vue?vue&type=style&index=0&id=129f1c28&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129f1c28"]])

export default __exports__